import React, { Component } from "react"
import { withRouter, Link } from "react-router-dom"
import * as constants from "../constants"
import Logo from "./Logo"
class SideMenu extends Component {
  render() {
    var menuItems = [
      { label: "Dashboard", link: "/", icon: "dashboard" },
      {
        label: "Unidades orçamentárias",
        link: "/unidades",
        icon: "location_city"
      },
      { label: "Contratos", link: "/contratos", icon: "description" },
      { label: "Distratos", link: "/distratos", icon: "warning" },
      { label: "Contratados", link: "/contratados", icon: "gavel" },
      {
        label: "Gestores de contrato",
        link: "/gestores",
        icon: "person_outline"
      },
      { label: "Fiscais de contrato", link: "/fiscais", icon: "pan_tool" },
      { label: "Documentos", link: "/documentos", icon: "note" },
      {
        label: "Relatórios de contrato",
        link: "/relatorios",
        icon: "picture_as_pdf"
      },
      { label: "Fiscalização", link: "/fiscalizacao", icon: "priority_high" }
    ]
    if (
      constants.haveRole(1) ||
      constants.haveRole(2)
    ) {
      menuItems.push({
        label: "Operadores",
        link: "/usuarios",
        icon: "account_circle"
      })
    }
    return (
      <div className="sidebar" data-color="as-blue">
        <Logo logo={Logo} siteName={"SGC-" + constants.getCidade()} />
        <div className="sidebar-wrapper">
          <ul className="nav">
            {menuItems.map((item, key) => {
              return (
                <li
                  className={
                    this.props.linkActive === item.label ? "active" : ""
                  }
                  key={key}
                >
                  <Link to={item.link}>
                    <i className="material-icons menu-itens">{item.icon}</i>
                    <p>{item.label}</p>
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }
}
export default withRouter(SideMenu)



// WEBPACK FOOTER //
// ./src/components/SideMenu.js